module.exports = __webpack_public_path__ + "img/google-play-badge.00949008.svg";